import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import jwtUtil from '@/utils/jwtUtil'
import vueConfig from '@/../vue.config'

Vue.use(VueRouter)

const routes = [
    {
        path: '/qrcode/:type/:id',
        name: 'QrCode',
        component: () => import('@/routes/UserCoachQrCode')
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('@/routes/Home')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/routes/Login'),
        props: true
    },
    {
        path: '/coaches',
        name: 'Coaches',
        component: () => import('@/routes/Coach')
    },
    {
        path: '/coaches/:mode',
        name: 'Coach Create Form',
        component: () => import('@/forms/CoachForm')
    },
    {
        path: '/coaches/:coachId/:mode',
        name: 'Coach Edit Form',
        component: () => import('@/forms/CoachForm')
    },
    {
        path: '/users',
        name: 'Users',
        component: () => import('@/routes/User')
    },
    {
        path: '/users/:mode',
        name: 'User Create Form',
        component: () => import('@/forms/UserForm')
    },
    {
        path: '/users/:userId/:mode',
        name: 'User Edit Form',
        component: () => import('@/forms/UserForm')
    },
    {
        path: '/sports',
        name: 'Sports',
        component: () => import('@/routes/Sport')
    },
    {
        path: '/sports/:mode',
        name: 'Sport Create Form',
        component: () => import('@/forms/SportForm')
    },
    {
        path: '/sports/:sportId/:mode',
        name: 'Sport Edit Form',
        component: () => import('@/forms/SportForm')
    },
    {
        path: '/sportClasses',
        name: 'Sport Classes',
        component: () => import('@/routes/SportClass')
    },
    {
        path: '/sportClasses/:mode',
        name: 'Sport Class Create Form',
        component: () => import('@/forms/SportClassForm')
    },
    {
        path: '/sportClasses/:sportClassId/:mode',
        name: 'Sport Class Edit Form',
        component: () => import('@/forms/SportClassForm')
    },
    {
        path: '/sportClass/:sportClassId/:type/attendance/qrcode',
        name: 'Sport Class Attendance QR Code',
        component: () => import('@/routes/SportClassAttendanceQRCode')
    },
    {
        path: '/memberships',
        name: 'Memberships',
        component: () => import('@/routes/Membership')
    },
    {
        path: '/memberships/:membershipId/:mode',
        name: 'Membership Edit Form',
        component: () => import('@/forms/MembershipForm')
    },
    {
        path: '/memberships/:mode',
        name: 'Membership Create Form',
        component: () => import('@/forms/MembershipForm')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: vueConfig.publicPath,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name === 'QrCode') {
        next()
        return
    }
    if (!(from.path.includes(to.path) || to.path.includes(from.path))) {
        store.dispatch('setPage', 1)
    }
    const token = store.getters.getToken
    if ((!token || (token && jwtUtil.isJwtExpired(token))) && to.name !== 'Login') {
        store.dispatch('logout').then(() => next({ path: '/login' }))
    } else if (token && !jwtUtil.isJwtExpired(token) && to.name === 'Login') {
        next({ path: '/' })
    } else if (!token && to.name === 'Login') {
        next()
    } else {
        next()
    }
})

export default router
